/**
 * Offers page — copy promo codes
 */
(function () {
  const root = document.querySelector('[data-nihooya-offers]');
  if (!root) return;

  const copiedLabel = 'Copied!';
  const copyFailLabel = 'Copy failed';

  function flashButton(button, label) {
    const textNode = button.querySelector('[data-nihooya-code-text]');
    if (!textNode) return;

    const original = textNode.textContent;
    textNode.textContent = label;
    button.classList.add('is-copied');

    window.setTimeout(() => {
      textNode.textContent = original;
      button.classList.remove('is-copied');
    }, 1600);
  }

  async function copyCode(code, button) {
    if (!code) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      flashButton(button, copiedLabel);
    } catch {
      flashButton(button, copyFailLabel);
    }
  }

  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nihooya-copy-code]');
    if (!button || !root.contains(button)) return;

    event.preventDefault();
    copyCode(button.getAttribute('data-nihooya-copy-code'), button);
  });
})();